import React from 'react';

import css from './IconAsterisk.module.css';

const IconASterisk = () => {
  return <span className={css.asterisk}>*</span>;
};

export default IconASterisk;
